import React from 'react';
import { TbArrowNarrowRight, TbArrowsUpDown } from 'react-icons/tb';
import { HiOutlineChartBarSquare } from 'react-icons/hi2';

interface MovementsProps {
  movements: any[];
  startDate: string;
  endDate: string;
  setStartDate: (d: string) => void;
  setEndDate: (d: string) => void;
}

const Movements: React.FC<MovementsProps> = ({ movements, startDate, endDate, setStartDate, setEndDate }) => {
  const formatDate = (d?: string) => {
    if (!d) return '';
    const date = new Date(d);
    return new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
  };

  const delta = (m: any) => (m.new_quantity ?? 0) - (m.old_quantity ?? 0);

  const type = (m: any) => {
    if (m.is_purchase) return 'Compra';
    if (m.is_consumption) return 'Consumo';
    if (m.is_manual) return 'Manual';
    if (m.is_system) return 'Sistema';
    return 'Movimiento';
  };

  const movimiento = (m: any) => {
    const from = m.storage_unit_id_from_name || '-';
    const to = m.storage_unit_id_to_name || '-';
    return (
      <span className="whitespace-nowrap">
        {from} <TbArrowNarrowRight className="inline-block align-middle opacity-80" /> {to}
      </span>
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', height: '100%' }}>
      {/* Date filter bar */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.75rem', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: '1 1 140px', minWidth: '140px' }}>
          <label style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-color)', opacity: 0.5 }}>Desde</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="stock-toolbar-date"
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: '1 1 140px', minWidth: '140px' }}>
          <label style={{ fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: 'var(--text-color)', opacity: 0.5 }}>Hasta</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="stock-toolbar-date"
          />
        </div>
        <span className="mp-badge-neutral" style={{ display: 'inline-flex', alignItems: 'center', padding: '4px 10px', borderRadius: '999px', fontSize: '0.75rem', fontWeight: 600, flexShrink: 0 }}>
          {movements?.length ?? 0} resultados
        </span>
      </div>

      {/* Movements table */}
      <div className="mp-table-card" style={{ flex: 1, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 360px)' }}>
          <table className="mp-table">
            <thead className="mp-table-head">
              <tr>
                <th style={{ width: '15%' }}>Fecha</th>
                <th style={{ width: '12%' }}>Tipo</th>
                <th>Movimiento</th>
                <th style={{ width: '15%' }}>Usuario</th>
                <th style={{ width: '80px', textAlign: 'center' }}>
                  <TbArrowsUpDown />
                </th>
              </tr>
            </thead>
            <tbody className="mp-table-body">
              {movements && movements.length > 0 ? (
                movements.map((m: any) => {
                  const d = delta(m);
                  return (
                    <tr key={m.movement_id}>
                      <td>
                        <div style={{ fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-color)' }}>{formatDate(m.local_timestamp || m.timestamp).split(',')[0]}</div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{formatDate(m.local_timestamp || m.timestamp).split(',')[1]}</div>
                      </td>
                      <td>
                        <span className="mp-badge-amber" style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                          {type(m)}
                        </span>
                      </td>
                      <td>{movimiento(m)}</td>
                      <td style={{ fontSize: '0.875rem', color: 'var(--text-color)' }}>{m.username || '-'}</td>
                      <td style={{ textAlign: 'center', fontWeight: 700, color: d >= 0 ? '#22c55e' : '#EF4444' }}>
                        {d >= 0 ? '+' : ''}{d}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5} style={{ padding: 0, border: 'none' }}>
                    <div className="mp-empty-state">
                      <HiOutlineChartBarSquare className="mp-empty-state-icon" />
                      <div className="mp-empty-state-title">Sin movimientos registrados</div>
                      <p style={{ fontSize: '0.875rem', color: 'var(--text-color)', opacity: 0.5 }}>No hay movimientos en el rango de fechas seleccionado</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {movements && movements.length > 0 && (
          <div className="mp-table-footer">
            <span style={{ fontSize: '0.75rem', color: 'var(--text-color)', opacity: 0.5 }}>{movements.length} movimiento{movements.length !== 1 ? 's' : ''}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Movements;
